import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  dialogContent: {
    maxWidth: "100%",
    padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  input: {
    marginBottom: "0 !important",
    "& label.Mui-focused": {
      color: "#142C5C",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#142C5C",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& fieldset": {
        borderColor: "#142C5C",
      },
      "&:hover fieldset": {
        borderColor: "#142C5C",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#142C5C",
      },
    },
  },
  button: {
    backgroundColor: "#142C5C !important",
    color: "#fff !important",
    borderRadius: "6px !important",
    fontSize: "14px !important",
    height: "40px !important",
    borderColor: "#142C5C !important",
    "&:hover": {
      backgroundColor: "#0f2247 !important",
    },
  },
  cancelButton: {
    backgroundColor: "#d32f2f",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#b71c1c",
    },
    marginRight: theme.spacing(2),
  },
  saveButton: {
    backgroundColor: "#2e7d32",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1b5e20",
    },
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: "10px",
  },
  tableContainer: {
    flex: 1,
    overflowY: "auto",
    minHeight: "calc(100vh - 100px)",
    maxHeight: "calc(100vh - 100px)",
    boxShadow: "none !important",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  tableCell: {
    fontSize: {
      xs: "14px !important",
      sm: "15px !important",
      md: "15px !important",
      lg: "16px !important",
      xl: "16px !important",
    },
    color: "#000 !important",
    fontWeight: "600 !important",
    padding: {
      xs: "10px 5px !important",
      sm: "15px 10px !important",
      md: "15px 10px !important",
      lg: "20px 15px !important",
      xl: "20px 15px !important",
    },
    backgroundColor: "#e0e0e0",
  },
  actionsCell: {
    textAlign: "right",
  },
  tableBody: {
    fontSize: {
      xs: "12px !important",
      sm: "13px !important",
      md: "14px !important",
      lg: "15px !important",
      xl: "15px !important",
    },
    color: "#333 !important",
    padding: {
      xs: "10px 5px !important",
      sm: "10px !important",
      md: "10px !important",
      lg: "10px 15px !important",
      xl: "10px 15px !important",
    },
  },
  table: {
    border: "1px solid rgba(224, 224, 224, 1)",
    minWidth: "100%",
    minHeight: "100%",
  },
  stickyHeader: {
    position: "sticky",
    top: "-1px",
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
}));

export default useStyles;
